import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';

// ----------------------------------------------------------------------
const base_url = '/v1/educationlevels';

const initialState = {
  isLoading: false,
  error: null,
  educationlevels: [],
  educationlevel: null,
};

const slice = createSlice({
  name: 'edulev',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET ALL
    getConfEduLevel(state, action) {
      state.isLoading = false;
      state.educationlevels = action.payload;
    },

    // GET ONE
    getOneConfEduLevel(state, action) {
      console.log('Masuk Ke Sini');
      state.isLoading = false;
      state.educationlevel = action.payload;
    },

    // CREATE
    createConfEduLevel(state, action) {
      const newdata = action.payload;
      state.isLoading = false;
      state.educationlevels = [...state.educationlevels, newdata];
    },

    // UPDATE
    updateConfEduLevel(state, action) {
      state.isLoading = false;
    },
  },
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function get() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(base_url);
      dispatch(slice.actions.getConfEduLevel(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getById(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`${base_url}/${id}/educationlevel`);
      dispatch(slice.actions.getOneConfEduLevel(response.data.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getByDescription(description) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`${base_url}/${description}/educationlevel`);
      dispatch(slice.actions.getOneConfEduLevel(response.data.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function create(newData) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`${base_url}`, newData);
      dispatch(slice.actions.createConfEduLevel(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

// ----------------------------------------------------------------------

export function update(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.put(`${base_url}`, data);
      dispatch(slice.actions.updateConfEduLevel(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function deleteById(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.delete(`${base_url}?id=${id}`);
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
